<template>
  <div class="shelves-log">
    <Search ref="search" @search="search"/>
    <Table :list="logList" @show-progress="handleShowProgress"/>
     <el-pagination
      :style="{ padding: '8px 16px', textAlign: 'right' }"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pagination.pageNo"
      :page-sizes="[10, 20, 50, 100]"
      :page-size="pagination.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="pagination.total"
    >
    </el-pagination>
    <BulkShelvesResults 
      ref="bulkShelvesResults" 
      @search="search"
      :publishSpeedResult="publishResult" 
      :percentage="publishPercenttage" 
      :pageId="pageId"/>
  </div>
</template>

<script>
import Search from './components/search.vue';
import Table from './components/table.vue';
import {getOperatorLog} from "@/servers/prod/log"
import BulkShelvesResults from '@/components/prod/center/dialogs/bulkShelvesResults.vue'
import { mapGetters, mapActions, mapMutations} from "vuex";

export default {
  components: {
    Search,
    Table,
    BulkShelvesResults
  },
  data() {
    return {
      logList: [],
      pagination: {
        pageNo: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  computed: {
    ...mapGetters(['speedResult', 'speedPercentage',"routerPrefix", 'subCodeMap']),
    pageId() {
      return this.routerPrefix+"updateLog"
    },
    publishResult() {
      return this.speedResult(this.routerPrefix+"updateLog")
    },
    publishPercenttage() {
      return this.speedPercentage(this.routerPrefix+"updateLog")
    }
  },
  methods: {
    ...mapActions(['fetch_channelByType', 'publishSpeed']),
    ...mapMutations(['setCurrentPage']),
    search() {
      this.pagination.pageNo = 1;
      this.fetch_operatorLog();
    },
    // 分页改变
    handleSizeChange(val) {
      this.pagination.pageNo = 1;
      this.pagination.pageSize = val;
      this.fetch_operatorLog();
    },
    handleCurrentChange(val) {
      this.pagination.pageNo = val;
      this.fetch_operatorLog();
    },
    async fetch_operatorLog() {
      const searchParams = this.$refs.search.method_getSearchForm();
      const {pageNo, pageSize} = this.pagination;
      const _params = {
        ...searchParams,
        operationType: 3,
        pageNo,
        pageSize
      }
      const res = await getOperatorLog(_params);
      if(!res) return;
      const {records, total} = res;
      this.logList = records;
      this.pagination.total = total;
    },
    handleShowProgress(rowData) {
      const subCode = this.subCodeMap[rowData.channel];
      let publishType = 'EDIT_ITEM';
      // 下架
      if (subCode === 30) {
        publishType = 'OFF_SALE_ITEM'
      } else if (subCode === 35) {
        publishType = 'BATCH_EDIT_ITEM'
      }
      this.setCurrentPage(this.pageId);
      this.publishSpeed({publishType, resultVisible: true})
    }
  },
  mounted() {
    this.search()
    this.fetch_channelByType({
      type: 3
    })
  },

}
</script>

<style lang="scss" scoped>

</style>
